import React from "react"
import { LogsClassificationsComponent } from "../../components/LogsClassifications"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"

export const LogsClassificationsPage = () => {
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <LogsClassificationsComponent />
    </DefaultPageComp>
  </>
}